/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adjustTransactionAmount} from '../api'

export const useMutationAdjustTransactionAmount = createReactQueryMutationHook('adjustTransactionAmount', adjustTransactionAmount)
